import { NotificationsStore } from '@rc-d2c/context-manager';
import { i18nInstance } from '@rc-d2c/i18n';
import { RcNotificationsProvider } from '@rc-d2c/shared-ui/RcNotifications';
import React, { useCallback, useEffect } from 'react';
import { useStore } from 'zustand';

import { useRouting } from './useRouting';

export function useNotifications(inPanel = false) {
  const { linkComponent } = useRouting();
  const { notifications, pushToaster, pushAlert, clearExpired, clearInfiniteNotifications, removeNotification } = useStore(
    NotificationsStore,
    (state) => state,
  );

  useEffect(function clearNotificationsUponNavigation() {
    return () => clearInfiniteNotifications();
  }, []);

  useEffect(
    function scheduleExpiredNotificationsClear() {
      const nextExpiration = Math.min(...notifications.map((notification) => notification.timestamp + notification.duration));

      if (Number.isFinite(nextExpiration)) {
        const timeout = setTimeout(clearExpired, nextExpiration - Date.now());
        return () => clearTimeout(timeout);
      }
    },
    [notifications],
  );

  const renderNotifications = useCallback(
    () => (
      <RcNotificationsProvider
        inPanel={inPanel}
        notifications={notifications.map((notif) => {
          return {
            ...notif,
            title: i18nInstance.t(notif.title, notif.titleParameters),
            description: 'description' in notif ? i18nInstance.t(notif.description || '', notif.descriptionParameters) : undefined,
          };
        })}
        linkComponent={linkComponent}
        handleRemoveNotification={removeNotification}
      />
    ),
    [notifications],
  );

  return {
    renderNotifications,
    pushToaster,
    pushAlert,
    removeNotification,
  };
}

export default useNotifications;
